<template>

    <button
        class="btn btn-info btn-xs"
        v-tooltip="tooltipText"
        @click="reconnect"
    >
        <i class="mdi mdi-account-multiple-plus"></i>
    </button>

</template>

<script>

import axios from 'axios';

export default {

    computed: {

        getRouteName() {
            return this.target === 'contacts' ?
                'api.v1.crm.contacts.reattach' :
                'api.v1.crm.companies.reattach';
        },

        tooltipText() {
            return this.type + ' weer koppelen';
        },

    },

    methods: {

        reconnect(){
            axios.patch(this.route(this.getRouteName,{
                uuid:this.uuid,
                target_uuid:this.targetUuid,
            }))
                .then(() => this.$emit('reconnectCompleted'))
                .catch(() => this.$emit('reconnectFailed'));
        },

    },

    props:{
        uuid: {
            type:String,
            required:true,
        },
        target: {
            type:String,
            required:true,
        },
        targetUuid: {
            type:String,
            required:true,
        },
        type: {
            type:String,
        },
    },

}

</script>
